/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_EmptyInputs */

const cs_calendar_empty = /** @type {(inputs: Calendar_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tomto měsíci nejsou naplánované úkoly.`)
};

const en_calendar_empty = /** @type {(inputs: Calendar_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No scheduled tasks this month.`)
};

/**
* | output |
* | --- |
* | "No scheduled tasks this month." |
*
* @param {Calendar_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_empty = /** @type {((inputs?: Calendar_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_empty(inputs)
	return cs_calendar_empty(inputs)
});